<a
  [routerLink]="['/admin', 'user', userId]"
  type="button"
  class="btn btn-primary d-block"
  ><fa-icon [icon]="faInfo" title="Detail View"></fa-icon
></a>
